<div class="date-picker-custom">
    <div class="float-left" style="padding: 0 10px 0 0;">
        <mat-form-field floatLabel="never" class="picker start-date">
            <mat-label>Start Date & Time</mat-label>
            <input placeholder="Start Date & Time" class="date-field-width date-picker-custom-input" data-input-type="start" [formControl]="startFormControl"
                type="text" readonly="readonly" matInput>
            <mat-icon matSuffix class="date-p-icon">event</mat-icon>
        </mat-form-field>
    </div>
    <div class="float-left" style="padding: 0 0 0 20px;">
        <mat-form-field floatLabel="never" class="m-0 picker end-date">
            <mat-label>End Date & Time</mat-label>
            <input placeholder="End Date & Time" class="date-field-width date-picker-custom-input" data-input-type="end" [formControl]="endFormControl"
                type="text" readonly="readonly" matInput>
            <mat-icon matSuffix class="date-p-icon">event</mat-icon>
        </mat-form-field>
    </div>
</div>